import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
})
export class BlogPageComponent implements OnInit {
  currentRoute: string;

  constructor(private router: Router) {
    // console.log(router.url);
    if (router.url == '/blogs/wp-admin/') {
      window.location.replace(window.location.href);
    }
  }

  ngOnInit(): void {}
}
